import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { useIsScheduleListV2Enabled } from 'hooks/useIsScheduleListV2Enabled';
import { selectUserIsLoaded } from 'selectors/general';

import VenueSchedulesContext from '../Contexts/VenueSchedulesContext';
import { isScheduleListV2EmptyDay } from './ScheduleListV2EmptyState.helpers';

export function useIsScheduleListV2EmptyDay() {
  const isScheduleListV2Enabled = useIsScheduleListV2Enabled();
  const isUserLoaded = useSelector(selectUserIsLoaded);
  const {
    isLoading: isLoadingSchedules,
    isLoadingMore: isLoadingMoreSchedules,
    schedules: allSchedules = [],
  } = useContext(VenueSchedulesContext);

  return isScheduleListV2EmptyDay({
    allSchedules,
    isLoadingMoreSchedules,
    isLoadingSchedules,
    isScheduleListV2Enabled,
    isUserLoaded,
  });
}
